import {getRandomString} from "@helpers/string";
import {IDeviceActivity, IDeviceActivityTransform} from "@containers/device/containers/deviceActivity/types";
import {useMemo} from "react";
import {getKeyTransformData} from "@helpers/transform/transform";
import {
    getLabelStatusDeviceActivity
} from "@containers/device/containers/deviceActivity/helpers/getLabelStatusDeviceActivity";
import {useTranslation} from "react-i18next";
import moment from "moment";

const statusTransformKey = getKeyTransformData('status')
const groupsTransformKey = getKeyTransformData('groupNames')
const lastEventTimeTimestampTransformKey = getKeyTransformData('lastEventTimeTimestamp')
const appVersionTransformKey = getKeyTransformData('appVersion')

export function useTransformData({data}: { data: IDeviceActivity[] }): {
    transformData: IDeviceActivityTransform[]
} {
    const {t} = useTranslation()


    const transformData: IDeviceActivityTransform[] = useMemo(() => {
        if (!data?.length) {
            return []
        }
        return data.map((item) => {

            const hasAppVersion = item?.appVersion && item?.appVersion !== 'null'
            const groupsNames = item.groupNames?.join(',')
            return {
                ...item,
                id: getRandomString(),
                [statusTransformKey]: t(getLabelStatusDeviceActivity(item?.status)),
                [groupsTransformKey]: groupsNames,
                [lastEventTimeTimestampTransformKey]: moment(item.lastEventTimeTimestamp * 1000).format('DD-MM-YYYY HH:mm:ss'),
                [appVersionTransformKey]: hasAppVersion ? item.appVersion : '---'
            }
        })
    }, [data])

    return {
        transformData
    }
}